import React from 'react';
import { Sparkles, TrendingUp, RefreshCw } from 'lucide-react';
import type { PredictionResult } from '../types/lottery';

interface PredictionCardProps {
  prediction: PredictionResult;
  onRegenerate: () => void;
}

export default function PredictionCard({ prediction, onRegenerate }: PredictionCardProps) {
  return (
    <div className="bg-white rounded-3xl shadow-lg p-8 border border-gray-100">
      <div className="flex items-center justify-between mb-6">
        <h3 className="flex items-center text-xl font-semibold text-gray-900">
          <Sparkles className="w-6 h-6 text-indigo-600 mr-2" />
          AI Prediction
        </h3>
        <span className="text-gray-500">{prediction.timestamp}</span>
      </div>
      
      <div className="flex flex-wrap gap-3 justify-center mb-8">
        {prediction.numbers.map((number) => (
          <div
            key={number}
            className="w-14 h-14 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-xl shadow-sm hover:shadow-md transition-all duration-200 hover:scale-105"
          >
            {number}
          </div>
        ))}
        <div
          className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center text-red-700 font-bold text-xl shadow-sm hover:shadow-md transition-all duration-200 hover:scale-105"
        >
          {prediction.powerball}
        </div>
      </div>
      
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center text-green-600 text-lg">
          <TrendingUp className="w-6 h-6 mr-2" />
          <span className="font-semibold">{prediction.confidence}% confidence</span>
        </div>
        <button 
          onClick={onRegenerate}
          className="inline-flex items-center px-6 py-3 bg-indigo-600 text-white text-base font-medium rounded-full hover:bg-indigo-700 transition-all duration-200 hover:scale-105"
        >
          <RefreshCw className="w-5 h-5 mr-2" />
          Regenerate Prediction
        </button>
        <p className="text-gray-500">Based on {prediction.basedOn}</p>
      </div>
    </div>
  );
}